module.exports = __webpack_public_path__ + "static/media/exterior-header@2x.b410eb15.jpg";